import React, { useEffect, useRef, useState } from "react";

interface TypewriterProps {
  toRotate: string[];
  typingSpeed?: number; // Avg ms per keystroke
  pauseBeforeDelete?: number; // Delay before deleting full word
}

const Typewriter: React.FC<TypewriterProps> = ({
  toRotate,
  typingSpeed = 150,
  pauseBeforeDelete = 1500,
}) => {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [pause, setPause] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const i = loopNum % toRotate.length;
    const fullTxt = toRotate[i];

    const tick = () => {
      if (pause) {
        timeoutRef.current = window.setTimeout(() => {
          setPause(false);
        }, pauseBeforeDelete);
        return;
      }

      const updatedText = isDeleting
        ? fullTxt.substring(0, text.length - 1)
        : fullTxt.substring(0, text.length + 1);

      setText(updatedText);

      let delta = typingSpeed - Math.random() * 50;
      if (isDeleting) delta /= 2;

      if (!isDeleting && updatedText === fullTxt) {
        setPause(true);
        setIsDeleting(true);
      } else if (isDeleting && updatedText === "") {
        setIsDeleting(false);
        setLoopNum((prev) => prev + 1);
      }

      timeoutRef.current = window.setTimeout(tick, delta);
    };

    timeoutRef.current = window.setTimeout(tick, 100);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [
    text,
    isDeleting,
    loopNum,
    pause,
    toRotate,
    typingSpeed,
    pauseBeforeDelete,
  ]);

  return (
    <span className="typewrite">
      <span className={`wrap ${pause ? "blinking-cursor" : ""}`}>{text}</span>
    </span>
  );
};

export default Typewriter;
